(function() {
    angular.module('tmx-app').factory('CustomersService', ['tmxResource', '$q', function( tmxResource, $q) {
        var Customers = tmxResource("CustomerMaster");
        Customers.getAllCustomers = function() {
            return Customers.all();
        };

        Customers.deleteById = function(id) {
         
            var deferred = $q.defer();
            Customers.getById(id).then(function(result) {
                deferred.resolve(result.$remove());
            });
      // item.$remove();
            return deferred.promise;
        };


        Customers.recievedLov = true;
        Customers.status = [
            { HiddenValue: "active",
                VisibleValue: "Active"
            },
            { HiddenValue: "inactive",
                VisibleValue: "Inactive"
            },
            { HiddenValue: "pending",
                VisibleValue: "Pending"
            }
        ];

        // ng-disabled='!CustomersCtrl.isEditable(dataItem) || !CustomersCtrl.checkPermission(\"Customers\",\"Edit\")'
        Customers.gridColumn = [
            {
                field: "CustomerName",
                title: "Customer",
                type: "text",                
                template: "<md-button ng-disabled='!CustomersCtrl.editPermission' class='tmx-primary-text-grid'  ng-click='CustomersCtrl.clickEdit(dataItem)' > {{dataItem.CustomerName}} </md-button> <div class='margin-bottom-2'><span class='chip' ng-style={{dataItem.StatusBKColor}} ng-bind='dataItem.Status'></span> <span class='subtitle'>{{dataItem.NationalIdentifierValue | cnic}}</span></div>",
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : CustomersCtrl.isFiltered('CustomerName')}\" >{{'Customer' | translate}}<i class='fa fa-filter' ng-if='CustomersCtrl.isFiltered(\"CustomerName\")' ></i></span>"
            },
            {
                field: "OrganizationName",
                title: "Organization",
                type: "text",  
                template: "{{dataItem.OrganizationName}}",
                hidden:false,        
                headerTemplate:"<span ng-class=\"{ 'filter-active' : CustomersCtrl.isFiltered('OrganizationName')}\" >{{'Organization' | translate}}<i class='fa fa-filter' ng-if='CustomersCtrl.isFiltered(\"OrganizationName\")' ></i></span>"
            },
            {
                field: "LastSalary",
                title: "Last Salary",
                type: "text",  
                template: "{{CustomersCtrl.formatAmount(dataItem.LastSalary)}}",
                hidden:false,        
                headerTemplate:"<span ng-class=\"{ 'filter-active' : CustomersCtrl.isFiltered('LastSalary')}\" >{{'Last Salary' | translate}}<i class='fa fa-filter' ng-if='CustomersCtrl.isFiltered(\"LastSalary\")' ></i></span>"
            },
            {
                field:"OutstandingAmount",
                title: "Outstanding Balance",
                type: "text",
                template: "{{CustomersCtrl.formatAmount(dataItem.OutstandingAmount,0)}}",
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('OutstandingAmount')}\" >{{'Outstanding Balance' | translate}} <i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"OutstandingAmount\")' ></i></span>",
                usePattern:false, 
                filterOperator: 'eq'                   
            },
            {
                field:"ModelSuggestion",
                title: "Model Suggestion",
                type: "text",
                template: "{{CustomersCtrl.IsRecommended(dataItem.SuggestedAmount)}}",
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('ModelSuggestion')}\" >{{'Model Suggestion' | translate}} <i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"ModelSuggestion\")' ></i></span>",
                usePattern:false,                    
            },
            {
                field:"SuggestedAmount",
                title: "Max Available Amount",
                type: "numeric",
                template: "{{CustomersCtrl.formatAmount(dataItem.SuggestedAmount)}}",
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : InboxCtrl.isFiltered('SuggestedAmount')}\" >{{'Max Available Amount' | translate}} <i class='fa fa-filter' ng-if='InboxCtrl.isFiltered(\"SuggestedAmount\")' ></i></span>",
                usePattern:false,                    
            },
            {
                field: "ContactNumber",
                title: "Contact Number",
                type: "numeric",                
                hidden:true,        
                headerTemplate:"<span ng-class=\"{ 'filter-active' : CustomersCtrl.isFiltered('ContactNumber')}\" >{{'ContactNumber' | translate}}<i class='fa fa-filter' ng-if='CustomersCtrl.isFiltered(\"ContactNumber\")' ></i></span>"
            },
            {
                field: "Status",
                title: "Status",
                type: "select",
                data: Customers.status,
                hidden:true,
                filterOperator: 'eq'  ,
                headerTemplate:"<span  ng-class=\"{ 'filter-active' : CustomersCtrl.isFiltered('Status')}\" >{{'Status' | translate}}<i class='fa fa-filter' ng-if='CustomersCtrl.isFiltered(\"Status\")' ></i></span>"
            },
            {
                title: "",
                width: "5%",
                template: "<md-menu md-position-mode=\"target-right target\" flex='none' class='menu-list-item'  md-offset='-20 60'>" +
                "<md-button class='menu-list-item-grid'  ng-click='$mdOpenMenu()' ><md-icon class='menu-list-item material-icons'>more_vert</md-icon></md-button>" +
                "<md-menu-content width='2'>" +
                "<md-menu-item><md-button ng-disabled='!CustomersCtrl.editPermission' aria-label='del' class='tmxMin' ng-click='CustomersCtrl.clickView(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>edit</md-icon>Edit</md-button></md-menu-item>" +
                "<md-menu-item ng-if='!dataItem.statusActive && !dataItem.statusPending' class='customStyle'>" +
                "<md-button aria-label='del' class='tmxMin' ng-click='CustomersCtrl.clickActivate(dataItem,$event)'>" +
                "<md-icon class='md-accent material-icons menu-list-item'>add_circle</md-icon>Activate</md-button>" +
                "</md-menu-item><md-menu-item   ng-if='dataItem.statusActive && !dataItem.statusPending' >" +
                "<md-button ng-disabled='!CustomersCtrl.DeletePrivilege'  aria-label='del' class='tmxMin' ng-click='CustomersCtrl.clickDeactivate(dataItem,$event)'> " +
                "<md-icon class='md-accent material-icons menu-list-item'>remove_circle</md-icon>Deactivate</md-button>" +
                "</md-menu-item></md-menu-content></md-menu>"
            }
        ];

        Customers.columns = angular.copy(Customers.gridColumn);
        Customers.getActiveCustomers =getActiveCustomers;
        function getActiveCustomers(id) {
            return Customers.getByAction('GetAllCustomers',true);
            }

        Customers.schema = {
            UserId: {
                duplicate: false,
                unique: false
            },
            UserCode: {
                duplicate: true,
                unique: true
            }
        };
    
        return Customers;
    }]);
})();
